import React from "react";
import Background from "./backgrounds/Background";
import { Layout } from "./Layout";
import { LayoutContext } from "./LayoutContext";

const LayoutContainer = React.memo(({ children }) => {
  const [ verticalPosition, setVerticalPosition ] = React.useState();
  const [ horizontalPosition, setHorizontalPosition ] = React.useState();
  const [ fullHeight, setFullHeight ] = React.useState();

  const propertySetters = React.useMemo(
    () => ({
      setVerticalPosition,
      setHorizontalPosition,
      setFullHeight,
    }),
    [ setVerticalPosition, setHorizontalPosition, setFullHeight ],
  );

  return (
    <LayoutContext.Provider value={propertySetters}>
      <Layout
        verticalPosition={verticalPosition}
        horizontalPosition={horizontalPosition}
        fullHeight={fullHeight}
      >
        <Background />
        {children}
      </Layout>
    </LayoutContext.Provider>
  );
});


export default LayoutContainer;



